import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import FeedingSiloList from './FeedingSiloList';

//redux

const FeedingSilo = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Operaciones', icon: 'icon-wrench' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Silos de Alimento' links={breadcrumbLinks} icon={'icon-ticket-minus'}/>
					<FeedingSiloList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default FeedingSilo;
